"use strict";

const _ = require('lodash');
const numeral = require('numeral');
const {formatDate} = require('../../formatters');

function format(k, {dateFormat, numberFormat} = {}) {
	if (_.isDate(k)) {
		return formatDate(k, dateFormat);
	}

	if (_.isNumber(k)) {
		return numeral(k).format(numberFormat || '0[.]00');
	}

	if (!k) {
		return '';
	}
	return k.toString();
}

module.exports = format;